export default class NullLog {
  log() {}
  info() {}
  warn() {}
  error() {}
}
